import { useEffect, useRef } from "react"
import React from 'react'

const useTitle = ({ title, bussines_name, description, icon }) => {


  // useEffect(() => {


  //Title Pages
  document.title = `${title} | ${bussines_name}`;

  //Description Pages
  if (description) {

    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;
  }

  //Icon Pages
  if (icon) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = icon;


  }

  // }, [title])



  return (<></>)
}

export default useTitle